import Hero from "../components/Hero";
import TrustStrip from "../components/TrustStrip";
import Features from "../components/Features";
import Industries from "../components/Industries";
import Specifications from "../components/Specifications";
import Pricing from "../components/Pricing";
import FAQ from "../components/FAQ";
import InstallerResources from "../components/InstallerResources";
import Contact from "../components/Contact";

export default function Home() {
    return (
        <main>
            <Hero />
            <TrustStrip />
            <Features />
            <Industries />
            <Specifications />
            <Pricing />
            <FAQ />
            <InstallerResources />
            <Contact />
        </main>
    );
}
